(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lb-about-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (!root || root.dataset.lbInit) return;
    root.dataset.lbInit = 'true';
    const targets = [...root.querySelectorAll('[data-lb-reveal]')];
    if (!targets.length) return;
    if (!('IntersectionObserver' in window)) { targets.forEach(el => el.classList.add('is-visible')); return; }
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) { entry.target.classList.add('is-visible'); observer.unobserve(entry.target); }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -60px 0px' });
    targets.forEach(el => observer.observe(el));
  }
  document.querySelectorAll('[data-lb-about-root]').forEach(init);
  document.addEventListener('shopify:section:load', e => init(e.target.querySelector('[data-lb-about-root]')));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lb-about-story"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (!root || root.dataset.lbInit) return;
    root.dataset.lbInit = 'true';
    const targets = [...root.querySelectorAll('[data-lb-about-reveal]')];
    if (!targets.length) return;
    if (!('IntersectionObserver' in window)) { targets.forEach(el => el.classList.add('is-visible')); return; }
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) { entry.target.classList.add('is-visible'); observer.unobserve(entry.target); }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -60px 0px' });
    targets.forEach(el => observer.observe(el));
  }
  document.querySelectorAll('.lb-about-story').forEach(section => init(section.closest('.lb-scope')));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lb-categories"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (!root || root.dataset.lbInit) return;
    root.dataset.lbInit = 'true';
    const track = root.querySelector('[data-lb-category-track]');
    root.querySelector('[data-lb-category-prev]')?.addEventListener('click', () => track.scrollBy({ left: -track.clientWidth, behavior: 'smooth' }));
    root.querySelector('[data-lb-category-next]')?.addEventListener('click', () => track.scrollBy({ left: track.clientWidth, behavior: 'smooth' }));
    root.querySelectorAll('[data-lb-filter-link]').forEach(link => link.addEventListener('click', event => {
      event.preventDefault();
      document.dispatchEvent(new CustomEvent('lb:filter', { detail: { filter: link.dataset.lbFilterLink } }));
      document.getElementById('lb-collection')?.scrollIntoView({ behavior: 'smooth' });
    }));
  }
  document.querySelectorAll('[data-lb-category-root]').forEach(init);
  document.addEventListener('shopify:section:load', e => init(e.target.querySelector('[data-lb-category-root]')));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lb-collection-color-filter"] && !Shopify.designMode) return;
  try {
    
(function () {
  // Normalizes a color name across Dutch/English/German (and common
  // misspellings) to one canonical key, so filtering still works correctly
  // even if the metafield value or this label gets translated by a
  // translation app and no longer matches the raw text.
  const COLOR_ALIASES = {
    wit: 'white', white: 'white', weiss: 'white', 'weiß': 'white',
    zwart: 'black', black: 'black', schwarz: 'black',
    goud: 'gold', gold: 'gold',
    grijs: 'grey', grey: 'grey', gray: 'grey', grau: 'grey',
    roze: 'pink', pink: 'pink', rosa: 'pink',
  };
  function normalizeColor(raw) {
    const key = (raw || '').trim().toLowerCase();
    return COLOR_ALIASES[key] || key;
  }
  window.lbNormalizeColor = normalizeColor;

  function init(root) {
    if (!root || root.dataset.lbInit) return;
    root.dataset.lbInit = 'true';
    const buttons = [...root.querySelectorAll('[data-lb-color-option]')];
    buttons.forEach(button => button.addEventListener('click', () => {
      buttons.forEach(b => b.classList.toggle('is-active', b === button));
      const raw = button.dataset.lbColorOption;
      const color = raw === 'all' ? 'all' : normalizeColor(raw);
      document.dispatchEvent(new CustomEvent('lb:color-filter', { detail: { color } }));
    }));
  }
  document.querySelectorAll('[data-lb-color-filter-root]').forEach(init);
  document.addEventListener('shopify:section:load', e => init(e.target.querySelector('[data-lb-color-filter-root]')));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lb-collection-grid"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (!root || root.dataset.lbInit) return;
    root.dataset.lbInit = 'true';

    let saved = new Set();
    try { saved = new Set(JSON.parse(localStorage.getItem('livingbright-saved') || '[]')); } catch (error) { saved = new Set(); }

    const toast = message => document.dispatchEvent(new CustomEvent('lb:toast', { detail: { message } }));
    const grid = root.querySelector('[data-lb-coll-card-grid]');

    const updateSaveButtons = scope => {
      (scope || root).querySelectorAll('[data-lb-save]').forEach(button => {
        const on = saved.has(button.dataset.lbSave);
        button.setAttribute('aria-pressed', String(on));
        button.innerHTML = on ? '&#9829;' : '&#9825;';
      });
    };

    // All per-card interactivity lives here so it can be re-run on cards
    // fetched later from other pages, not just the ones present at load.
    const bindCardScope = scope => {
      scope.querySelectorAll('[data-lb-swipe-track]').forEach(track => {
        if (track.dataset.lbBound) return;
        track.dataset.lbBound = 'true';
        const media = track.closest('.lb-coll-card-media');
        const dotsWrap = media?.querySelector('[data-lb-swipe-dots]');
        const dots = dotsWrap ? [...dotsWrap.children] : [];
        const prevBtn = media?.querySelector('[data-lb-swipe-prev]');
        const nextBtn = media?.querySelector('[data-lb-swipe-next]');
        const slideCount = track.children.length;

        const updateUI = () => {
          const index = Math.round(track.scrollLeft / track.clientWidth);
          dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
          if (prevBtn) prevBtn.disabled = index <= 0;
          if (nextBtn) nextBtn.disabled = index >= slideCount - 1;
        };
        track.addEventListener('scroll', updateUI, { passive: true });
        prevBtn?.addEventListener('click', event => {
          event.preventDefault();
          track.scrollBy({ left: -track.clientWidth, behavior: 'smooth' });
        });
        nextBtn?.addEventListener('click', event => {
          event.preventDefault();
          track.scrollBy({ left: track.clientWidth, behavior: 'smooth' });
        });
        updateUI();
      });

      scope.querySelectorAll('[data-lb-save]').forEach(button => {
        if (button.dataset.lbBound) return;
        button.dataset.lbBound = 'true';
        button.addEventListener('click', () => {
          const id = button.dataset.lbSave;
          if (saved.has(id)) saved.delete(id); else saved.add(id);
          localStorage.setItem('livingbright-saved', JSON.stringify([...saved]));
          updateSaveButtons();
          document.dispatchEvent(new CustomEvent('lb:saved-changed'));
          toast(saved.has(id) ? 'Saved to your edit.' : 'Removed from your edit.');
        });
      });
      updateSaveButtons(scope);

      scope.querySelectorAll('[data-lb-open-dialog]').forEach(button => {
        if (button.dataset.lbBound) return;
        button.dataset.lbBound = 'true';
        button.addEventListener('click', () => document.getElementById(button.dataset.lbOpenDialog)?.showModal());
      });
      scope.querySelectorAll('dialog').forEach(dialog => {
        if (dialog.dataset.lbBound) return;
        dialog.dataset.lbBound = 'true';
        dialog.querySelector('.lb-dialog-close')?.addEventListener('click', () => dialog.close());
        dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
      });

      scope.querySelectorAll('[data-lb-variant-select]').forEach(select => {
        if (select.dataset.lbBound) return;
        select.dataset.lbBound = 'true';
        select.addEventListener('change', () => {
          select.closest('.lb-quick-content').querySelector('[data-lb-variant-id]').value = select.value;
        });
      });

      scope.querySelectorAll('[data-lb-add-form]').forEach(form => {
        if (form.dataset.lbBound) return;
        form.dataset.lbBound = 'true';
        form.addEventListener('submit', async event => {
          event.preventDefault();
          const button = form.querySelector('button[type=submit]');
          const status = form.querySelector('.lb-add-status');
          button.disabled = true;
          status.textContent = 'Adding...';
          try {
            const response = await fetch(window.Shopify.routes.root + 'cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) });
            if (!response.ok) throw new Error('Could not add this item.');
            status.textContent = 'Added to your bag.';
            toast('Added to your bag.');
            document.dispatchEvent(new CustomEvent('lb:cart:refresh'));
          } catch (error) {
            status.textContent = error.message;
          } finally {
            button.disabled = false;
          }
        });
      });
    };

    bindCardScope(root);

    // Fetch every other page of the collection (once) and merge the product
    // cards into the grid, so the colour filter can match products beyond
    // whatever page happened to be loaded first.
    let allPagesLoaded = false;
    let loadingPromise = null;
    const loadRemainingPages = () => {
      if (allPagesLoaded || loadingPromise || !grid) return Promise.resolve();
      const totalPages = parseInt(grid.dataset.totalPages || '1', 10);
      const currentPage = parseInt(grid.dataset.currentPage || '1', 10);
      const collectionUrl = grid.dataset.collectionUrl;
      const sortBy = grid.dataset.sortBy;
      const sectionId = grid.dataset.sectionId;
      if (totalPages <= 1 || !collectionUrl || !sectionId) {
        allPagesLoaded = true;
        return Promise.resolve();
      }
      const pagesToFetch = [];
      for (let p = 1; p <= totalPages; p += 1) {
        if (p !== currentPage) pagesToFetch.push(p);
      }
      loadingPromise = Promise.all(pagesToFetch.map(p => {
        const url = `${collectionUrl}?page=${p}&sort_by=${encodeURIComponent(sortBy)}&section_id=${sectionId}`;
        return fetch(url)
          .then(res => res.text())
          .then(html => {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const fetchedGrid = doc.querySelector('[data-lb-coll-card-grid]');
            if (!fetchedGrid) return;
            [...fetchedGrid.children].forEach(node => {
              if (node.matches('[data-lb-coll-card]') || node.tagName === 'DIALOG') {
                grid.appendChild(node);
              }
            });
          })
          .catch(() => {});
      })).then(() => {
        allPagesLoaded = true;
        bindCardScope(grid);
      });
      return loadingPromise;
    };

    // Colour filter: instant client-side filtering, no page reload.
    // Loads the rest of the collection in the background the first time a
    // specific colour (not "All") is chosen.
    // Colors are normalized across Dutch/English/German so filtering still
    // works even if the metafield value has been translated and no longer
    // matches the filter button's raw text.
    const COLOR_ALIASES = {
      wit: 'white', white: 'white', weiss: 'white', 'weiß': 'white',
      zwart: 'black', black: 'black', schwarz: 'black',
      goud: 'gold', gold: 'gold',
      grijs: 'grey', grey: 'grey', gray: 'grey', grau: 'grey',
      roze: 'pink', pink: 'pink', rosa: 'pink',
    };
    const normalizeColor = raw => {
      const key = (raw || '').trim().toLowerCase();
      return COLOR_ALIASES[key] || key;
    };
    const applyColorFilter = color => {
      const cards = [...root.querySelectorAll('[data-lb-coll-card]')];
      let shown = 0;
      cards.forEach(card => {
        const cardColors = (card.dataset.color || '').split(',').map(s => normalizeColor(s.trim())).filter(Boolean);
        const matches = color === 'all' || cardColors.includes(color);
        card.hidden = !matches;
        if (matches) shown += 1;
      });
      const countEl = root.querySelector('.lb-coll__count');
      if (countEl) {
        const label = countEl.textContent.replace(/^\d+\s*/, '');
        countEl.textContent = `${shown} ${label}`;
      }
      if (grid) grid.classList.toggle('is-empty', shown === 0);
      if (shown === 0) toast('No mirrors match that colour yet.');
    };

    document.addEventListener('lb:color-filter', event => {
      const color = (event.detail.color || 'all').toLowerCase();
      if (color === 'all') {
        applyColorFilter(color);
        return;
      }
      loadRemainingPages().then(() => applyColorFilter(color));
    });

    root.querySelector('[data-lb-sort-select]')?.addEventListener('change', event => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', event.target.value);
      window.location.href = url.toString();
    });

    // Checkbox-style filters (availability, type, etc.) apply instantly,
    // but only touch their own param — anything else already in the URL
    // (like an applied price range) is preserved rather than rebuilt.
    root.querySelectorAll('[data-lb-filter-input]').forEach(field => field.addEventListener('change', () => {
      const params = new URLSearchParams(window.location.search);
      if (field.checked) params.set(field.name, field.value); else params.delete(field.name);
      window.location.search = params.toString();
    }));

    // Price range only submits when Apply is clicked, so both min and max
    // can be filled in first instead of jumping to results after the first field.
    root.querySelector('[data-lb-price-apply]')?.addEventListener('click', () => {
      const params = new URLSearchParams(window.location.search);
      root.querySelectorAll('[data-lb-price-input]').forEach(field => {
        if (field.value !== '') params.set(field.name, field.value); else params.delete(field.name);
      });
      window.location.search = params.toString();
    });

    // Filter dropdowns: click a label to toggle its panel; only one open at a
    // time; clicking outside or pressing Escape closes whichever is open.
    root.querySelectorAll('[data-lb-filter-dd-toggle]').forEach(toggle => {
      toggle.addEventListener('click', event => {
        event.stopPropagation();
        const dd = toggle.closest('[data-lb-filter-dd]');
        const wasOpen = dd.classList.contains('is-open');
        root.querySelectorAll('[data-lb-filter-dd]').forEach(other => {
          other.classList.remove('is-open');
          other.querySelector('[data-lb-filter-dd-toggle]')?.setAttribute('aria-expanded', 'false');
        });
        if (!wasOpen) {
          dd.classList.add('is-open');
          toggle.setAttribute('aria-expanded', 'true');
        }
      });
    });
    document.addEventListener('click', () => {
      root.querySelectorAll('[data-lb-filter-dd]').forEach(dd => {
        dd.classList.remove('is-open');
        dd.querySelector('[data-lb-filter-dd-toggle]')?.setAttribute('aria-expanded', 'false');
      });
    });
    root.querySelector('[data-lb-filterbar]')?.addEventListener('click', event => event.stopPropagation());
    document.addEventListener('keydown', event => {
      if (event.key === 'Escape') {
        root.querySelectorAll('[data-lb-filter-dd]').forEach(dd => dd.classList.remove('is-open'));
      }
    });
  }
  document.querySelectorAll('[data-lb-coll-root]').forEach(init);
  document.addEventListener('shopify:section:load', e => init(e.target.querySelector('[data-lb-coll-root]')));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lb-collection"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (!root || root.dataset.lbInit) return;
    root.dataset.lbInit = 'true';

    let saved = new Set();
    try { saved = new Set(JSON.parse(localStorage.getItem('livingbright-saved') || '[]')); } catch (error) { saved = new Set(); }

    const toast = message => document.dispatchEvent(new CustomEvent('lb:toast', { detail: { message } }));

    // Track which image is showing as the user swipes/scrolls each card's gallery
    root.querySelectorAll('[data-lb-swipe-track]').forEach(track => {
      const dotsWrap = track.closest('.lb-product-media')?.querySelector('[data-lb-swipe-dots]');
      if (!dotsWrap) return;
      const dots = [...dotsWrap.children];
      track.addEventListener('scroll', () => {
        const index = Math.round(track.scrollLeft / track.clientWidth);
        dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
      }, { passive: true });
    });

    const updateSaveButtons = () => {
      root.querySelectorAll('[data-lb-save]').forEach(button => {
        const on = saved.has(button.dataset.lbSave);
        button.setAttribute('aria-pressed', String(on));
        button.innerHTML = on ? '&#9829;' : '&#9825;';
      });
    };

    const setFilter = filter => {
      root.querySelectorAll('[data-lb-filter]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.lbFilter === filter)));
      const grids = [...root.querySelectorAll('[data-lb-tab-grid]')];
      let shown = 0;
      grids.forEach(grid => {
        const isActive = grid.dataset.lbTabGrid === filter;
        grid.hidden = !isActive;
        if (isActive) {
          if (grid.hasAttribute('data-lb-saved-grid')) {
            // The saved grid holds every product; only reveal the saved ones.
            grid.querySelectorAll('[data-lb-product]').forEach(card => {
              const isSaved = saved.has(card.dataset.productId);
              card.hidden = !isSaved;
              if (isSaved) shown += 1;
            });
          } else {
            shown += grid.querySelectorAll('[data-lb-product]').length;
          }
        }
      });
      if (!shown && filter === 'saved') toast('Save a mirror to see it here.');
    };

    root.querySelectorAll('[data-lb-filter]').forEach(button => button.addEventListener('click', () => setFilter(button.dataset.lbFilter)));
    document.addEventListener('lb:filter', event => setFilter(event.detail.filter));

    root.querySelectorAll('[data-lb-open-dialog]').forEach(button => button.addEventListener('click', () => document.getElementById(button.dataset.lbOpenDialog)?.showModal()));
    root.querySelectorAll('dialog').forEach(dialog => {
      dialog.querySelector('.lb-dialog-close')?.addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
    });

    root.querySelectorAll('[data-lb-save]').forEach(button => button.addEventListener('click', () => {
      const id = button.dataset.lbSave;
      if (saved.has(id)) saved.delete(id); else saved.add(id);
      localStorage.setItem('livingbright-saved', JSON.stringify([...saved]));
      updateSaveButtons();
      document.dispatchEvent(new CustomEvent('lb:saved-changed'));
      toast(saved.has(id) ? 'Saved to your edit.' : 'Removed from your edit.');
    }));

    root.querySelectorAll('[data-lb-variant-select]').forEach(select => select.addEventListener('change', () => {
      select.closest('.lb-quick-content').querySelector('[data-lb-variant-id]').value = select.value;
    }));

    root.querySelectorAll('[data-lb-add-form]').forEach(form => form.addEventListener('submit', async event => {
      event.preventDefault();
      const button = form.querySelector('button[type=submit]');
      const status = form.querySelector('.lb-add-status');
      button.disabled = true;
      status.textContent = 'Adding...';
      try {
        const response = await fetch(window.Shopify.routes.root + 'cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) });
        if (!response.ok) throw new Error('Could not add this item.');
        status.textContent = 'Added to your bag.';
        toast('Added to your bag.');
        document.dispatchEvent(new CustomEvent('lb:cart:refresh'));
      } catch (error) {
        status.textContent = error.message;
      } finally {
        button.disabled = false;
      }
    }));

    updateSaveButtons();

    const firstTabButton = root.querySelector('[data-lb-filter]');
    let defaultFilter = firstTabButton ? firstTabButton.dataset.lbFilter : 'all';
    // Safety net: if the default tab has no products configured yet
    // (merchant hasn't picked any), fall back to "All mirrors" instead of
    // showing an empty section.
    if (defaultFilter && defaultFilter !== 'all' && defaultFilter !== 'saved') {
      const grid = root.querySelector(`[data-lb-tab-grid="${defaultFilter}"]`);
      const hasAny = grid && grid.querySelectorAll('[data-lb-product]').length > 0;
      if (!hasAny) {
        const allButton = root.querySelector('[data-lb-filter="all"]');
        if (allButton) defaultFilter = 'all';
      }
    }
    const urlFilter = new URLSearchParams(window.location.search).get('filter');
    setFilter(urlFilter || defaultFilter);
  }
  document.querySelectorAll('[data-lb-collection-root]').forEach(init);
  document.addEventListener('shopify:section:load', e => init(e.target.querySelector('[data-lb-collection-root]')));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lb-contact-faq"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (!root || root.dataset.lbInit) return;
    root.dataset.lbInit = 'true';
    const targets = [...root.querySelectorAll('[data-lb-reveal]')];
    if (!targets.length) return;
    if (!('IntersectionObserver' in window)) {
      targets.forEach(el => el.classList.add('is-visible'));
      return;
    }
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -60px 0px' });
    targets.forEach(el => observer.observe(el));
  }
  document.querySelectorAll('[data-lb-faq-root]').forEach(init);
  document.addEventListener('shopify:section:load', e => init(e.target.querySelector('[data-lb-faq-root]')));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lb-faqpage"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (!root || root.dataset.lbInit) return;
    root.dataset.lbInit = 'true';
    const targets = [...root.querySelectorAll('[data-lb-reveal]')];
    if (!targets.length) return;
    if (!('IntersectionObserver' in window)) { targets.forEach(el => el.classList.add('is-visible')); return; }
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) { entry.target.classList.add('is-visible'); observer.unobserve(entry.target); }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
    targets.forEach(el => observer.observe(el));
  }
  document.querySelectorAll('[data-lb-faqpage-root]').forEach(init);
  document.addEventListener('shopify:section:load', e => init(e.target.querySelector('[data-lb-faqpage-root]')));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lb-finish"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (!root || root.dataset.lbInit) return;
    root.dataset.lbInit = 'true';
    const prefix = root.dataset.handlePrefix;
    root.querySelectorAll('[data-lb-finish]').forEach(button => button.addEventListener('click', () => {
      const name = button.dataset.lbFinish;
      root.querySelectorAll('[data-lb-finish]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
      const imageWrap = root.querySelector('[data-lb-finish-image-wrap]');
      const image = imageWrap ? imageWrap.querySelector('img') : null;
      if (image && button.dataset.image) { image.removeAttribute('srcset'); image.removeAttribute('sizes'); image.src = button.dataset.image; image.alt = button.dataset.label || name; }
      // The label comes from the section settings, so it follows the store language.
      const label = button.dataset.label || (name[0].toUpperCase() + name.slice(1));
      const nameEl = root.querySelector('[data-lb-finish-name]');
      if (nameEl) nameEl.textContent = label;
      const captionEl = root.querySelector('[data-lb-finish-caption]');
      if (captionEl) captionEl.textContent = label;
      // Without a handle prefix there is no product URL to build, so keep the
      // section's own link rather than sending shoppers to a missing page.
      const link = root.querySelector('[data-lb-finish-link]');
      if (link && prefix) {
        const rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        link.href = `${rootUrl}products/${prefix}${name}`;
      }
    }));
  }
  document.querySelectorAll('[data-lb-finish-root]').forEach(init);
  document.addEventListener('shopify:section:load', e => init(e.target.querySelector('[data-lb-finish-root]')));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lb-header"]) return;
  try {
    
(function () {
  if (window.__lbHeaderInit) return;
  window.__lbHeaderInit = true;

  const header = document.querySelector('[data-lb-header]');
  const menuToggle = document.querySelector('.lb-menu-toggle');
  const mobileNav = document.querySelector('.lb-mobile-nav');
  const searchDialog = document.querySelector('[data-lb-search-dialog]');
  const cartDrawer = document.querySelector('[data-lb-cart-drawer]');
  const cartScrim = document.querySelector('[data-lb-cart-scrim]');
  const toastEl = document.querySelector('[data-lb-toast]');
  let toastTimer;

  // Mobile menu
  menuToggle?.addEventListener('click', () => {
    const open = mobileNav.classList.toggle('is-open');
    menuToggle.setAttribute('aria-expanded', String(open));
    menuToggle.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
  });

  // Language switcher (desktop + mobile instances share the same markup pattern)
  document.querySelectorAll('[data-lb-locale-switcher]').forEach(switcher => {
    const toggle = switcher.querySelector('[data-lb-locale-toggle]');
    toggle?.addEventListener('click', event => {
      event.stopPropagation();
      const open = !switcher.classList.contains('is-open');
      document.querySelectorAll('[data-lb-locale-switcher]').forEach(s => {
        s.classList.remove('is-open');
        s.querySelector('[data-lb-locale-toggle]')?.setAttribute('aria-expanded', 'false');
      });
      if (open) {
        switcher.classList.add('is-open');
        toggle.setAttribute('aria-expanded', 'true');
      }
    });
  });
  document.addEventListener('click', () => {
    document.querySelectorAll('[data-lb-locale-switcher]').forEach(s => {
      s.classList.remove('is-open');
      s.querySelector('[data-lb-locale-toggle]')?.setAttribute('aria-expanded', 'false');
    });
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') {
      document.querySelectorAll('[data-lb-locale-switcher]').forEach(s => s.classList.remove('is-open'));
    }
  });

  mobileNav?.querySelectorAll('a').forEach(link => link.addEventListener('click', () => {
    mobileNav.classList.remove('is-open');
    menuToggle?.setAttribute('aria-expanded', 'false');
  }));

  // Search dialog
  document.querySelectorAll('.lb-search-open').forEach(button => button.addEventListener('click', () => {
    searchDialog?.showModal();
    searchDialog?.querySelector('input[type=search]')?.focus();
  }));
  document.querySelectorAll('dialog').forEach(dialog => {
    dialog.querySelector('.lb-dialog-close')?.addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
  });

  // Scroll progress bar on header bottom border
  const updateScrollProgress = () => {
    if (!header) return;
    const scrollTop = window.scrollY || document.documentElement.scrollTop;
    const max = document.documentElement.scrollHeight - window.innerHeight;
    const pct = max > 0 ? Math.min(100, Math.max(0, (scrollTop / max) * 100)) : 0;
    header.style.setProperty('--lb-scroll', pct + '%');
  };
  window.addEventListener('scroll', updateScrollProgress, { passive: true });
  window.addEventListener('resize', updateScrollProgress);
  updateScrollProgress();

  // Fixed/pinned header (bulletproof alternative to position:sticky)
  const spacer = document.querySelector('[data-lb-header-spacer]');
  const announcement = document.querySelector('[data-lb-announcement]');
  const updatePin = () => {
    if (!header) return;
    const annHeight = announcement ? announcement.offsetHeight : 0;
    const scrollTop = window.scrollY || document.documentElement.scrollTop;
    if (scrollTop > annHeight) {
      if (!header.classList.contains('is-pinned')) {
        spacer.style.height = header.offsetHeight + 'px';
        spacer.classList.add('is-active');
        header.classList.add('is-pinned');
      }
    } else {
      header.classList.remove('is-pinned');
      spacer.classList.remove('is-active');
      spacer.style.height = '0';
    }
  };
  window.addEventListener('scroll', updatePin, { passive: true });
  window.addEventListener('resize', updatePin);
  updatePin();

  // Keep --header-group-height accurate for any sticky element on the page
  // (product gallery, how-it-works sticky media, etc. all offset from this).
  const updateHeaderHeightVar = () => {
    if (!header) return;
    document.documentElement.style.setProperty('--header-group-height', `${header.offsetHeight}px`);
    document.body.style.setProperty('--header-group-height', `${header.offsetHeight}px`);
  };
  window.addEventListener('resize', updateHeaderHeightVar);
  window.addEventListener('load', updateHeaderHeightVar);
  updateHeaderHeightVar();
  // Header height can change once webfonts finish loading
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(updateHeaderHeightVar);
  }

  // Toast (listened to from any section via a custom event)
  window.lbToast = message => {
    if (!toastEl) return;
    toastEl.textContent = message;
    toastEl.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => toastEl.classList.remove('is-visible'), 2200);
  };
  document.addEventListener('lb:toast', event => window.lbToast(event.detail?.message || ''));

  // Saved / wishlist count badge
  const updateSavedCount = () => {
    let saved = [];
    try { saved = JSON.parse(localStorage.getItem('livingbright-saved') || '[]'); } catch (error) { saved = []; }
    document.querySelectorAll('[data-lb-saved-count]').forEach(el => { el.textContent = saved.length || ''; });
  };
  document.addEventListener('lb:saved-changed', updateSavedCount);
  updateSavedCount();

  // Cart drawer
  const money = cents => (window.Shopify && window.Shopify.formatMoney)
    ? window.Shopify.formatMoney(cents, window.theme?.moneyFormat)
    : '$' + (cents / 100).toFixed(2);

  const renderCart = cart => {
    const itemsWrap = document.querySelector('[data-lb-cart-items]');
    const foot = document.querySelector('[data-lb-cart-foot]');
    if (!itemsWrap) return;
    document.querySelectorAll('[data-lb-cart-count]').forEach(el => { el.textContent = cart.item_count; });
    if (!cart.items.length) {
      itemsWrap.innerHTML = '<p class="lb-cart-empty">Your bag is empty.</p>';
      if (foot) foot.hidden = true;
      return;
    }
    itemsWrap.innerHTML = cart.items.map(item => `
      <div class="lb-cart-item" data-key="${item.key}">
        <img src="${item.image ? item.image.replace('.jpg', '_150x.jpg') : ''}" alt="${item.product_title}" loading="lazy">
        <div>
          <div class="lb-cart-item-title">${item.product_title}</div>
          ${item.variant_title ? `<div class="lb-cart-item-variant">${item.variant_title}</div>` : ''}
          <div class="lb-cart-item-row">
            <div class="lb-cart-qty">
              <button type="button" data-lb-qty-down aria-label="Decrease quantity">&minus;</button>
              <span>${item.quantity}</span>
              <button type="button" data-lb-qty-up aria-label="Increase quantity">+</button>
            </div>
            <span class="lb-cart-item-price">${money(item.final_line_price)}</span>
          </div>
          <button type="button" class="lb-cart-remove" data-lb-remove>Remove</button>
        </div>
      </div>`).join('');
    if (foot) {
      foot.hidden = false;
      const subtotalEl = foot.querySelector('[data-lb-cart-subtotal]');
      if (subtotalEl) subtotalEl.textContent = money(cart.total_price);
    }
  };

  const fetchCart = () => fetch(window.Shopify.routes.root + 'cart.js').then(r => r.json());

  const changeLine = (key, quantity) => fetch(window.Shopify.routes.root + 'cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ id: key, quantity })
  }).then(r => r.json()).then(renderCart);

  const openCartDrawer = () => {
    cartDrawer?.classList.add('is-open');
    cartScrim?.classList.add('is-open');
    cartDrawer?.setAttribute('aria-hidden', 'false');
    fetchCart().then(renderCart).catch(() => {});
  };
  const closeCartDrawer = () => {
    cartDrawer?.classList.remove('is-open');
    cartScrim?.classList.remove('is-open');
    cartDrawer?.setAttribute('aria-hidden', 'true');
  };

  document.querySelector('[data-lb-cart-open]')?.addEventListener('click', event => {
    event.preventDefault();
    openCartDrawer();
  });
  document.querySelector('[data-lb-cart-close]')?.addEventListener('click', closeCartDrawer);
  cartScrim?.addEventListener('click', closeCartDrawer);

  document.addEventListener('click', event => {
    const item = event.target.closest('.lb-cart-item');
    if (!item) return;
    const key = item.dataset.key;
    if (event.target.matches('[data-lb-qty-up]')) {
      const qty = parseInt(item.querySelector('.lb-cart-qty span').textContent, 10) + 1;
      changeLine(key, qty);
    } else if (event.target.matches('[data-lb-qty-down]')) {
      const qty = Math.max(0, parseInt(item.querySelector('.lb-cart-qty span').textContent, 10) - 1);
      changeLine(key, qty);
    } else if (event.target.matches('[data-lb-remove]')) {
      changeLine(key, 0);
    }
  });

  // Refresh + auto-open drawer whenever a product is added elsewhere on the page
  document.addEventListener('lb:cart:refresh', () => {
    fetchCart().then(cart => { renderCart(cart); openCartDrawer(); });
  });

  fetchCart().then(renderCart).catch(() => {});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lb-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (!root || root.dataset.lbInit) return;
    root.dataset.lbInit = 'true';

    // Desktop cross-fade slider
    const slides = [...root.querySelectorAll('.lb-hero-desktop-slides .lb-hero-image')];
    let active = 0;
    const show = index => {
      if (!slides.length) return;
      active = (index + slides.length) % slides.length;
      slides.forEach((slide, i) => slide.classList.toggle('is-active', i === active));
      const count = root.querySelector('[data-lb-hero-count]');
      if (count) count.textContent = `${String(active + 1).padStart(2, '0')} / ${String(slides.length).padStart(2, '0')}`;
    };
    root.querySelector('[data-lb-hero-prev]')?.addEventListener('click', () => show(active - 1));
    root.querySelector('[data-lb-hero-next]')?.addEventListener('click', () => show(active + 1));

    // Mobile swipeable banner with dots
    const track = root.querySelector('[data-lb-hero-mobile-track]');
    const dots = root.querySelector('[data-lb-hero-mobile-dots]');
    if (track && dots && !dots.childElementCount) {
      const items = [...track.children];
      const step = () => items.length > 1 ? items[1].offsetLeft - items[0].offsetLeft : track.clientWidth;
      items.forEach((item, index) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.setAttribute('aria-label', `Show slide ${index + 1}`);
        dot.setAttribute('aria-pressed', String(index === 0));
        dot.addEventListener('click', () => track.scrollTo({ left: step() * index, behavior: 'smooth' }));
        dots.append(dot);
      });
      const updateDots = () => {
        const index = Math.min(Math.round(track.scrollLeft / step()), items.length - 1);
        [...dots.children].forEach((dot, i) => dot.setAttribute('aria-pressed', String(i === index)));
      };
      track.addEventListener('scroll', updateDots, { passive: true });
    }
  }
  document.querySelectorAll('[data-lb-hero-root]').forEach(init);
  document.addEventListener('shopify:section:load', e => init(e.target.querySelector('[data-lb-hero-root]')));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lb-light"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (!root || root.dataset.lbInit) return;
    root.dataset.lbInit = 'true';
    const imageWrap = root.querySelector('[data-lb-light-image-wrap]');
    const image = imageWrap ? imageWrap.querySelector('img') : null;
    const label = root.querySelector('[data-lb-light-label]');
    const description = root.querySelector('[data-lb-light-description]');
    let copy = {};
    try { copy = JSON.parse(root.dataset.lbLightCopy || '{}'); } catch (error) { copy = {}; }
    root.querySelectorAll('[data-lb-light]').forEach(button => button.addEventListener('click', () => {
      root.querySelectorAll('[data-lb-light]').forEach(item => item.setAttribute('aria-selected', String(item === button)));
      if (image) { image.removeAttribute('srcset'); image.removeAttribute('sizes'); image.src = button.dataset.image; image.alt = `LivingBright mirror with ${button.dataset.lbLight} lighting`; }
      if (label) label.textContent = copy[button.dataset.lbLight][0];
      if (description) description.textContent = copy[button.dataset.lbLight][1];
    }));
    root.querySelector('[data-lb-brightness]')?.addEventListener('input', event => {
      if (image) image.style.filter = `brightness(${0.45 + Number(event.target.value) * 0.0055})`;
      event.target.nextElementSibling.value = `${event.target.value}%`;
    });
  }
  document.querySelectorAll('[data-lb-light-root]').forEach(init);
  document.addEventListener('shopify:section:load', e => init(e.target.querySelector('[data-lb-light-root]')));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lb-lookbook"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (!root || root.dataset.lbInit) return;
    root.dataset.lbInit = 'true';
    const track = root.querySelector('[data-lb-lookbook-track]');
    const items = [...track.children];
    const step = () => items.length > 1 ? items[1].offsetLeft - items[0].offsetLeft : track.clientWidth;
    const move = direction => track.scrollBy({ left: step() * direction, behavior: 'smooth' });
    root.querySelector('[data-lb-gallery-prev]')?.addEventListener('click', () => move(-1));
    root.querySelector('[data-lb-gallery-next]')?.addEventListener('click', () => move(1));
    const dots = root.querySelector('[data-lb-gallery-dots]');
    items.forEach((item, index) => {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.setAttribute('aria-label', `Show gallery image ${index + 1}`);
      dot.addEventListener('click', () => track.scrollTo({ left: step() * index, behavior: 'smooth' }));
      dots.append(dot);
    });
    const update = () => {
      const index = Math.min(Math.round(track.scrollLeft / step()), items.length - 1);
      const visible = Math.max(1, Math.round(track.clientWidth / step()));
      const countEl = root.querySelector('[data-lb-gallery-count]');
      if (countEl) countEl.textContent = `${String(index + 1).padStart(2, '0')} - ${String(Math.min(index + visible, items.length)).padStart(2, '0')} / ${String(items.length).padStart(2, '0')}`;
      [...dots.children].forEach((dot, i) => dot.setAttribute('aria-pressed', String(i === index)));
    };
    track.addEventListener('scroll', update, { passive: true });
    track.addEventListener('keydown', event => {
      if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') { event.preventDefault(); move(event.key === 'ArrowRight' ? 1 : -1); }
    });
    update();
  }
  document.querySelectorAll('[data-lb-lookbook-root]').forEach(init);
  document.addEventListener('shopify:section:load', e => init(e.target.querySelector('[data-lb-lookbook-root]')));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lb-search-results"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (!root || root.dataset.lbInit) return;
    root.dataset.lbInit = 'true';

    let saved = new Set();
    try { saved = new Set(JSON.parse(localStorage.getItem('livingbright-saved') || '[]')); } catch (error) { saved = new Set(); }

    const toast = message => document.dispatchEvent(new CustomEvent('lb:toast', { detail: { message } }));

    root.querySelectorAll('[data-lb-swipe-track]').forEach(track => {
      const dotsWrap = track.closest('.lb-coll-card-media')?.querySelector('[data-lb-swipe-dots]');
      if (!dotsWrap) return;
      const dots = [...dotsWrap.children];
      track.addEventListener('scroll', () => {
        const index = Math.round(track.scrollLeft / track.clientWidth);
        dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
      }, { passive: true });
    });

    const updateSaveButtons = () => {
      root.querySelectorAll('[data-lb-save]').forEach(button => {
        const on = saved.has(button.dataset.lbSave);
        button.setAttribute('aria-pressed', String(on));
        button.innerHTML = on ? '&#9829;' : '&#9825;';
      });
    };

    root.querySelectorAll('[data-lb-save]').forEach(button => button.addEventListener('click', () => {
      const id = button.dataset.lbSave;
      if (saved.has(id)) saved.delete(id); else saved.add(id);
      localStorage.setItem('livingbright-saved', JSON.stringify([...saved]));
      updateSaveButtons();
      document.dispatchEvent(new CustomEvent('lb:saved-changed'));
      toast(saved.has(id) ? 'Saved to your edit.' : 'Removed from your edit.');
    }));
    updateSaveButtons();

    root.querySelectorAll('[data-lb-open-dialog]').forEach(button => button.addEventListener('click', () => document.getElementById(button.dataset.lbOpenDialog)?.showModal()));
    root.querySelectorAll('dialog').forEach(dialog => {
      dialog.querySelector('.lb-dialog-close')?.addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
    });

    root.querySelectorAll('[data-lb-variant-select]').forEach(select => select.addEventListener('change', () => {
      select.closest('.lb-quick-content').querySelector('[data-lb-variant-id]').value = select.value;
    }));

    root.querySelectorAll('[data-lb-add-form]').forEach(form => form.addEventListener('submit', async event => {
      event.preventDefault();
      const button = form.querySelector('button[type=submit]');
      const status = form.querySelector('.lb-add-status');
      button.disabled = true;
      status.textContent = 'Adding...';
      try {
        const response = await fetch(window.Shopify.routes.root + 'cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) });
        if (!response.ok) throw new Error('Could not add this item.');
        status.textContent = 'Added to your bag.';
        toast('Added to your bag.');
        document.dispatchEvent(new CustomEvent('lb:cart:refresh'));
      } catch (error) {
        status.textContent = error.message;
      } finally {
        button.disabled = false;
      }
    }));
  }
  document.querySelectorAll('[data-lb-search-root]').forEach(init);
  document.addEventListener('shopify:section:load', e => init(e.target.querySelector('[data-lb-search-root]')));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lb-shapes"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (!root || root.dataset.lbInit) return;
    root.dataset.lbInit = 'true';
    root.querySelectorAll('[data-lb-filter-link]').forEach(link => link.addEventListener('click', event => {
      event.preventDefault();
      document.dispatchEvent(new CustomEvent('lb:filter', { detail: { filter: link.dataset.lbFilterLink } }));
      document.getElementById('lb-collection')?.scrollIntoView({ behavior: 'smooth' });
    }));
  }
  document.querySelectorAll('[data-lb-shapes-root]').forEach(init);
  document.addEventListener('shopify:section:load', e => init(e.target.querySelector('[data-lb-shapes-root]')));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
